import NavBar from '../navbar/navbar';
import image from '../images/footballfield.jpg';
import { Button, H2, H3, Label } from '../reusable-components';
import { useTranslation } from "react-i18next";
import useShallowRounds from '../rounds/useShallowRounds';
import { ChangeEvent, useState } from 'react';
import useApiBetting from './useApiBetting';
import { getDateString, getRoundName } from '../common/RoundHelper';
import Moment from 'react-moment';
import ConfirmPaymentApi from './confirmpaymentapi';
import moment from 'moment';
import dbetImage from '../images/dbet_syndicate.jpeg';
import videoImage from '../images/video_syndicate.png';
import mrvegasImage from '../images/mrvegas_syndicate.jpeg';
import megaImage from '../images/mega_syndicate.jpeg';
import orangeStadium from '../images/expekt_background.png';
import gogoStadium from '../images/expekt_background.png';
import woodLanding from '../images/wood_landing.png';
import leoLanding from '../images/lion_landing.png';
import unibetLanding from '../images/unibet_landing.jpg';
import hajperBackground from '../images/hajper_background.png';
import snabbareBackground from '../images/snabbare_background.png';
import reviantBackground from '../images/reviant_background.jpeg';
import lylloBackground from '../images/lyllo_background.png';
import stuganBackground from '../images/background_stugan.png';
import kryssBackground from '../images/kryss_landing.jpeg';
import hardBackground from '../images/hard_background.png';
import { IsLeo, themeC } from '../theme/themehelper';
import { Box, Grid, List, ListItem, SxProps, Table, TableBody, TableCell, TableHead, TableRow, Theme, Typography, useMediaQuery } from '@mui/material';
import { ShallowRound } from '../models/round';

export default function ApiBetting() {
  const { t } = useTranslation();
  const [shallowRounds] = useShallowRounds(true, false);
  const [file, setFile] = useState<File>();
  const [info, setInfo] = useState<string | null>();
  const { uploadFile } = useApiBetting();
  const [response, setResponse] = useState<any>();
  const [showConfirm, setShowConfirm] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const isSmallScreen = useMediaQuery('(max-width: 950px)');

  let rounds = shallowRounds?.rounds;
  let backgroundImage = `url(${image})`;
  let backgroundHeight = "376px";

  const styleInfoBox: SxProps<Theme> = {
    background: 'var(--list-boxes-primary)',
    width: '300px'
  }

  const styleTile: SxProps<Theme> = {
    width: isSmallScreen ? '90%' : '600px',
    padding: '10px 10px 10px 30px',
    background: 'var(--list-boxes-primary)',
    margin: '10px 0px 60px 0px'
  }

  const styleTitle: SxProps<Theme> = {
    fontSize: '14px',
    fontWeight: 'bold',
    margin: '10px 10px 10px 0px',
    color: "var(--text-black)"
  }
  const styleValue: SxProps<Theme> = {
    fontSize: '14px',
    margin: '10px 10px 10px 0px',
    color: "var(--text-black)"
  }

  const listStyle: SxProps<Theme> = { display: 'list-item' };

  const styleInfoRow: SxProps<Theme> = {
    justifyContent: "space-between"
  }


  if (window.theme === themeC.Dbet) {
    backgroundImage = `url(${dbetImage})`;
  }

  if (window.theme === themeC.Video) {
    backgroundImage = `url(${videoImage})`;
  }

  if (window.theme === themeC.MrVegas) {
    backgroundImage = `url(${mrvegasImage})`;
  }

  if (window.theme === themeC.Mega) {
    backgroundImage = `url(${megaImage})`;
  }

  if (window.theme === themeC.Orange) {
    backgroundImage = `url(${orangeStadium})`;
  }

  if (window.theme === themeC.GoGo) {
    backgroundImage = `url(${gogoStadium})`;
  }

  if (window.theme === themeC.Wood) {
    backgroundImage = `url(${woodLanding})`;
  }

  if (window.theme === themeC.Lion) {
    backgroundImage = `url(${leoLanding})`;
  }

  if (window.theme === themeC.ComeOn) {
    backgroundImage = `url(${unibetLanding})`;
  }

  if (window.theme === themeC.Hajper) {
    backgroundImage = `url(${hajperBackground})`;
  }

  if (window.theme === themeC.Snabbare || window.theme === themeC.Reviant) {
    backgroundImage = window.theme === themeC.Reviant
        ? `url(${reviantBackground})`
        : `url(${snabbareBackground})`;
  }

  if (window.theme === themeC.Lyllo) {
    backgroundImage = `url(${lylloBackground})`;
  }

  if (window.theme === themeC.Stugan) {
    backgroundImage = `url(${stuganBackground})`;
  }

  if (window.theme === themeC.Kryss) {
    backgroundImage = `url(${kryssBackground})`;
  }

  if (window.theme === themeC.Hard) {
    backgroundImage = `url(${hardBackground})`;
    styleTitle.color = "var(--text-white)";
    styleValue.color = "var(--text-white)";
    listStyle.color = "var(--text-white)";
  }

  if (window.theme === themeC.Green) {
    backgroundImage = `url(${unibetLanding})`;
  }

  let locale = t('locale');

  if (IsLeo(window.theme)) {
    backgroundHeight = "260px";
  }

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setFile(e.target.files[0]);
    }
  };

  const closeConfirm = () => {
    setShowConfirm(false);
    setFile(undefined);
    setInfo(null);
  }

  const handleUploadClick = () => {
    if (!file) {
      return;
    }
    setShowConfirm(true);
  }

  const uploadFileAfterConfirm = () => {
    setSubmitting(true);

    uploadFile(file as File).then(resp => {
      setResponse(resp);
      setSubmitting(false);
    })
  }

  let fileReader = new FileReader();
  let round = undefined;
  let count = undefined;

  if (file) {
    fileReader.onload = function () {
      setInfo(fileReader.result as string);
    };
    fileReader.readAsText(file)
  }

  if (info) {
    var roundId = info.split('\n')[0];
    roundId = roundId.replace('\r', '');
    round = rounds?.filter(r => r.id === roundId)[0];
    let lines = info.split('\n');
    count = lines.filter(l => l.indexOf('E') >= 0).length;
  }

  let roundName = getRoundName(round, t);

  let futureRounds: ShallowRound[] = [];
  if (rounds !== undefined) {
    futureRounds = rounds.filter(r => moment(r.openTo) > moment(new Date()) && r.name.indexOf("Survivor") === -1);
  }

  return (
    <>
      <NavBar whichToUnderline="7" balanceUpdateId="0" />

      <Grid container sx={{
        width: "100%",
        height: backgroundHeight,
        background: backgroundImage,
        justifyContent: "center",
        alignItems: "center",
        backgroundPosition: window.theme === themeC.Green ? "center 52%" : "center center",
        backgroundSize: window.theme === themeC.Green ? "200%" : "cover",
        backgroundRepeat: "no-repeat",
        color: "var(--text-white)",
        position: "relative"
      }}>
        {window.theme === themeC.Green &&
          <Box sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "linear-gradient(270deg, rgba(0, 0, 0, 0.45) 0%, rgba(0, 125, 63, 0.3) 100%)",
            zIndex: 1,
          }} />
        }
        <H2 color="#fff" style={{ position: 'relative', zIndex: 2 }}>
          {t('api_betting')}
        </H2>
      </Grid>
      <Grid container alignItems="center" direction="column" sx={{
        background: 'var(--list-background)',
        padding: "20px"
      }}>
        <Grid container direction="column" sx={styleTile}>

          <H3>{t('api:info')}</H3>

          {
            <Grid container direction="column" sx={styleInfoBox}>

              <Grid container sx={styleInfoRow}>
                <Typography sx={styleTitle}>{t('file')}:</Typography>
                <Typography sx={styleValue}>{file && `${file.name}`}</Typography>
              </Grid>
              <Grid container sx={styleInfoRow}>
                <Typography sx={styleTitle}>{t('round')}:</Typography>
                <Typography sx={styleValue}>{round && round.id}</Typography>
              </Grid>
              <Grid container sx={styleInfoRow}>
                <Typography sx={styleTitle}>{t('name')}:</Typography>
                <Typography sx={styleValue}>{round && roundName}</Typography>
              </Grid>
              <Grid container sx={styleInfoRow}>
                <Typography sx={styleTitle}>{t('starts')}:</Typography>
                <Typography sx={styleValue}>{round && <Moment format={"yyyy-MM-DD"} locale={locale}>{round.openTo}</Moment>}</Typography>
              </Grid>
              <Grid container sx={styleInfoRow}>
                <Typography sx={styleTitle}>{t('number_of_rows')}:</Typography>
                <Typography sx={styleValue}>{count}</Typography>
              </Grid>
            </Grid>
          }

          <Grid container direction={isSmallScreen ? "column" : "row"} sx={{ alignItems: "center", padding: "10px" }}>
            <Grid sx={{ padding: "10px" }}>
              <input
                style={{
                  opacity: 0,
                  width: "0.1px",
                  height: "0.1px",
                  position: "absolute"
                }}

                id="file" type="file" onChange={e => handleFileChange(e)} />
              <Label htmlFor="file">
                {t('select_file')}
              </Label>
            </Grid>
            <Grid sx={{ padding: "10px" }}>
              <Button className="btn-upload" disabled={round === undefined || file === undefined || count === 0} onClick={() => handleUploadClick()}>{t('upload')}</Button>
            </Grid>
          </Grid>
        </Grid>

        <Grid container sx={styleTile}>

          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={styleTitle}>{t('id')}</TableCell>
                <TableCell sx={styleTitle}>{t('starts')}</TableCell>
                <TableCell sx={styleTitle}>{t('name')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {
                futureRounds.map((round, index) => {

                  return (
                    <TableRow key={'row' + index}>
                      <TableCell sx={styleValue}>{round.id}</TableCell>
                      <TableCell sx={styleValue}>{getDateString(round, t)}</TableCell>
                      <TableCell sx={styleValue}>{getRoundName(round, t)}</TableCell>
                    </TableRow>);

                })
              }
            </TableBody>
          </Table>

        </Grid>

        <Grid container sx={styleTile}>

          <H3>{t('api:format.title')}</H3>

          <Grid container direction="column">
            <List sx={{ listStyleType: "disc", padding: "20px" }}>
              <ListItem sx={listStyle}>{t('api:format.p1')}</ListItem>
              <ListItem sx={listStyle}>{t('api:format.p2')}</ListItem>
              <ListItem sx={listStyle}>{t('api:format.p3')}</ListItem>
              <ListItem sx={listStyle}>{t('api:format.p4')}</ListItem>
              <ListItem sx={listStyle}>{t('api:format.p5')}</ListItem>
            </List>

            <Grid container direction="column">
              <H3>{t('api:example.title')}:</H3>
              <Typography sx={styleValue}> {t('api:example.row1')}</Typography>
              <Typography sx={styleValue}>{t('api:example.row2')}</Typography>
              <Typography sx={styleValue}>{t('api:example.row3')}</Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {showConfirm && round && (
        <ConfirmPaymentApi
          toggle={closeConfirm}
          submitting={submitting}
          response={response}
          uploadFile={uploadFileAfterConfirm}
          roundId={round.id}
          count={count}
        />
      )}
    </>
  );
}